import tw from 'twin.macro'
import { useContext } from 'react'
import { MCOnboardingsContext } from '../mc-onboardings/MCOnboardings.context'
import { TableSearch } from 'src/components/shared/table/TableSearch'

export const MCOnboardingsHeader = () => {
  const { setSearchQuery, searchQuery } = useContext(MCOnboardingsContext)

  return (
    <div
      css={tw`flex flex-row items-center gap-4 bg-white px-4 py-3 border-0 border-b border-t border-solid border-[#EDEDED]`}
    >
      <TableSearch searchQuery={searchQuery} onChangeSearchQuery={setSearchQuery} />
    </div>
  )
}
